import axios from 'axios'

let config = {
  baseURL: '/sendmail'
}

const mailAPI = axios.create(config)

export function sendEmailFromTemplate (from, to, subject, template, data) {
  const formData = new FormData()
  formData.append('from', from)
  formData.append('to', to)
  formData.append('subject', subject)
  formData.append('template', template)
  formData.append('h:X-Mailgun-Variables', JSON.stringify(data))
  return mailAPI.post('/messages', formData)
}
